export default __webpack_public_path__ + "static/casablanca-4299b19cfa1cb37f737a68d1536785c5.png";